<template>
    <div>
        <Drawer/>
        <AppBar></AppBar>
        <v-main>
            <v-slide-x-reverse-transition hide-on-leave origin="left right">
                <router-view></router-view>
            </v-slide-x-reverse-transition>
        </v-main>
    </div>
</template>

<script>
    import Drawer from "../components/drawer/Drawer";
    import AppBar from "../components/AppBar";

    export default {
        name: "AppPage",
        components: {AppBar, Drawer},
        mounted() {
            const currentUser = JSON.parse(localStorage.getItem('user'));
            
            if(currentUser==null){
                this.$router.replace({name:"Panel"})
            }
            if (currentUser.user_role === "Admin") {
                this.$router.push({name: "APDashBoard"})
            } else if (currentUser.user_role === "Student") {
                this.$router.push({name: "APDashBoard"})
            } else if (currentUser.user_role === "Tutor") {
                this.$router.push({name: "APDashBoard"})
            }
            this.$store.dispatch("getSubjects")
            this.$store.dispatch("getPermissions")
            this.$store.dispatch("getClasses")
        }
    }
</script>

<style scoped>

</style>